import React from "react";

import ScooterIcon from "@/components/Icons/scooter_stylized.svg";
const DeliveryScooterLogo: React.FC = () => (
  <div
    className="bg-white mb-lg mx-auto rounded-full relative flex justify-center items-center"
    style={{ height: 104, width: 104 }}
  >
    <ScooterIcon aria-hidden width="80" />
  </div>
);

export default DeliveryScooterLogo;
